import type { Code } from './code-compiletime.ts';

export default import.meta.compileTime<Code>('./code-compiletime.ts');